





































































import ajax from '@/lib/ajax';
import { Component, Vue } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import BookingDetails from '@/components/Bookings/BookingDetails.vue';
import BookingRequirements from '@/components/Bookings/BookingRequirements.vue';
import BookingWorkers from '@/components/Bookings/BookingWorkers.vue';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue'
import BookingCancel from '@/components/Bookings/BookingCancel.vue';
import BookingStatus from '@/components/Bookings/Display/BookingStatus.vue';
import BookingStatusEnum from '@/models/Bookings/BookingStatus';
import EntityType from '@/models/Shared/EntityType';
import Notes from '@/components/Notes/Notes.vue';

@Component({
  name: 'Booking',
  components: { Alert, BookingDetails, BookingRequirements, BookingWorkers, BookingCancel, BookingStatus, Notes }
})
export default class extends GiganautVue {

  bookingStatusEnum = BookingStatusEnum;
  entityType = EntityType.Booking;

  async beforeMount() {
        await BookingDetailsModule.getAgencyUsers();
  }

  get currentBooking() {
    return BookingDetailsModule.currentBooking;
  }

  get loading() {
    return BookingDetailsModule.loading;
  }

  async navigateToBookingList() {
    this.$router.push({ name: PageNames.AgencyBookings });
  }

  // async createDocument() {
  //   await ajax.post(`/api/v1/sys/agencies/123a93b4-3c5e-46aa-bcaa-47999280fae5/docgenerator`, {
  //       "documentTemplateId": "f05076c7-7387-4e35-a297-912503f251b6",
  //       "companyId": "d430b91d-99fd-4f7b-a003-ee4df2201f84",
  //       "entityId": "9424b0b6-dd5c-45d9-a09a-2370084e2f72"
  //   })
  //   .then(response => {
  //        var w = window.open('about:blank');
  //         w.document.open();
  //         w.document.write(response.data);
  //         w.document.close();
  //   })
  //   // .catch(error => {
  //   //   AppModule.handleApiError(error);
  //   //   this.setLoadingDialog(false);
  //   // })
    
  // }

}
